import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/Invoice.css";
import { getInvoiceData } from '../Api/ViewPostedInvoice';
import { Base_URL } from "../url";
import { useReactToPrint } from "react-to-print";


const CreditNoteFooter=()=>{
    return(
    <div class="terms-container">
            {/* <!-- Terms Header --> */}
            <div class="terms-header">
              {/* <div class="terms-title">TERMS & CONDITION :</div> */}
              <div class="company-name"> Siddhidhata Ayurved Private Limited</div>
            </div>

            {/* <!-- Terms Content --> */}
            {/* <div class="terms-content">
              <ul class="terms-list">
                <li>(1) Goods once sold will not be taken back.</li>
                <li>(2) Goods are sold on an understanding that the buyer is holding all requisite valid Drug, Municipal and Tax.</li>
                <li>(3) Sold subject to our price list terms.</li>
                <li>(4) Interest @ 21% per annum will be applicable on payments made beyond due date.</li>
                <li>(5) The Company staffs are not allowed to take advance or money/stock transactions either in cash or in kind. Any claims in this regard will not be entertained.</li>
                <li>(6) I/WE hereby clarify that My / Our registration certificate under the S.T. Act 1959 is in force on the date on which the sales of the goods specified in this Bill/Cash Memorandum is made by me/us in the regular course of my/our business.</li>
              </ul>
            </div> */}

            {/* <!-- Signature Section --> */}
            <div class="signature-section">
              <div class="signature-box">
                <div class="signature-space"></div>
                {/* <div class="signature-label">E-Invoice Verification</div> */}
              </div>

              <div class="signature-box">
                <div class="signature-space"></div>
                {/* <div class="signature-label">E-Invoice Verifier</div> */}
              </div>

              <div class="signature-box">
                <div class="signature-space"></div>
                <div class="signature-label">AUTHORISED SIGNATORY</div>
              </div>
            </div>

            {/* terms conteent end */}

          </div>
    )
}
export default CreditNoteFooter;